import { render } from "./ErrorMessage.vue?vue&type=template&id=0e68615a&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"

import "./ErrorMessage.vue?vue&type=style&index=0&id=0e68615a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e68615a"

export default script